import { jwtPayload } from '@/lib/utils'

export const ROLES = {
  basic: 1,
  agency_admin: 2,
  agency_admin_exc: 2,
  state_admin: 3,
  state_admin_exc: 3,
  naddi_admin: 4,
  internal_admin: 5,
}

export function currentGroup() {
  let idToken = window.localStorage.getItem('idToken')
  if (!idToken) return false
  let parsedToken = jwtPayload(idToken)
  return parsedToken['role']
}

export function status() {
  let idToken = window.localStorage.getItem('idToken')
  if (!idToken) return 'logged_out'
  let parsedToken = jwtPayload(idToken)
  return parsedToken['status']
}

export function sworn() {
  let idToken = window.localStorage.getItem('idToken')
  if (!idToken) return false
  // we are applying sworn based restrictions to these roles only
  let swornRequiredGroups = [
    "agency_admin",
    "state_admin",
    "naddi_admin"
  ]
  let parsedToken = jwtPayload(idToken)
  let currentGroup = parsedToken['role']
  return !swornRequiredGroups.includes(currentGroup) || parsedToken['sworn']
}

export function basic() {
  return ROLES[currentGroup()] >= ROLES.basic
}

export function agencyAdmin() {
  return ROLES[currentGroup()] >= ROLES.agency_admin
}

export function agencyAdminException() {
  return ROLES[currentGroup()] >= ROLES.agency_admin_exc
}

export function stateAdmin() {
  return ROLES[currentGroup()] >= ROLES.state_admin
}

export function stateAdminException() {
  return ROLES[currentGroup()] >= ROLES.state_admin_exc
}

export function naddiAdmin() {
  return ROLES[currentGroup()] >= ROLES.naddi_admin
}

export function internalAdmin() {
  return ROLES[currentGroup()] >= ROLES.internal_admin
}

export function admin() {
  // Is this user at least any kind of admin?
  return ROLES[currentGroup()] >= ROLES.agency_admin
}

export const AuthorizationPlugin = {
  install(Vue) {
    Vue.prototype.$auth = {
      basic() {
        return basic()
      },
      agencyAdmin() {
        return agencyAdmin()
      },
      agencyAdminException() {
        return agencyAdminException()
      },
      stateAdmin() {
        return stateAdmin()
      },
      stateAdminException() {
        return stateAdminException
      },
      naddiAdmin() {
        return naddiAdmin()
      },
      internalAdmin() {
        return internalAdmin()
      },
      admin() {
        return admin()
      },
      sworn() {
        return sworn()
      }
    }
  },
}
